import Vue from "vue";

export default {
  getLoanTypes({ commit, state }) {
    const params = {
      page: state.currentPage,
      perPage: state.perPage,
      ...(state.searchQuery != "" && { search_query: state.searchQuery }),
    };
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/settings/loantypes`, { params })
        .then(response => {
          commit("loanTypesTotal", response.data.total);
          commit("loanTypes", response.data.results);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchLoanTypeByEmployee(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/settings/loantypes/employee/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchLoanRequests({ commit, state }, params2) {
    const params = {
      page: state.loanRequestsCurrentPage,
      perPage: state.loanRequestsPerPage,
      ...(params2.loan_type_id != "undefined" && {
        loan_type_id: params2.loan_type_id,
      }),
      ...(params2.start_date != "undefined" && {
        start_date: params2.start_date,
      }),
      ...(params2.end_date != "undefined" && { end_date: params2.end_date }),
    };
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/requests`, { params })
        .then(response => {
          commit("loanRequests", response.data.results);
          commit("loanRequestsTotal", response.data.total);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchLoanRequestById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/requests/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  createLoanRequest(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/loans/requests`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  editLoanRequest(_, payload) {
    const { id } = payload;
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/payroll/loans/requests/${id}`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  deleteLoanRequests(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/loans/requests/delete`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  handleLoanRequestsSizeChange({ commit, dispatch }, page) {
    commit("loanRequestsPerPage", page);
    commit("loanRequestsCurrentPage", 1);
    dispatch("fetchLoanRequests", {});
  },
  handleLoanRequestsCurrentChange({ commit, dispatch }, page) {
    commit("loanRequestsCurrentPage", page);
    dispatch("fetchLoanRequests", {});
  },

  fetchLoanRequestsApproval({ commit, state }, params2) {
    const params = {
      page: state.loanRequestsApprovalCurrentPage,
      perPage: state.loanRequestsApprovalPerPage,
      ...(params2.loan_type_id != "undefined" && {
        loan_type_id: params2.loan_type_id,
      }),
      ...(params2.start_date != "undefined" && {
        start_date: params2.start_date,
      }),
      ...(params2.end_date != "undefined" && { end_date: params2.end_date }),
    };
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/requests/approvals`, { params })
        .then(response => {
          commit("loanRequestsApproval", response.data.results);
          commit("loanRequestsApprovalTotal", response.data.total);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  approveLoanRequests(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/loans/requests/approve`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  rejectLoanRequests(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/loans/requests/reject`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  handleLoanRequestsApprovalSizeChange({ commit, dispatch }, page) {
    commit("loanRequestsApprovalPerPage", page);
    commit("loanRequestsApprovalCurrentPage", 1);
    dispatch("fetchLoanRequestsApproval", {});
  },
  handleLoanRequestsApprovalCurrentChange({ commit, dispatch }, page) {
    commit("loanRequestsApprovalCurrentPage", page);
    dispatch("fetchLoanRequestsApproval", {});
  },
};
